export default __webpack_public_path__ + "static/media/1490.6063f738.png";